export default __webpack_public_path__ + "static/media/rooftops_kleber.9a2a2f75.jpg";